import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const DATE_FORMAT = 'DD-MM-YYYY' as const;

export const formatGridDate = (date: string | undefined, locale: string): string => {
  const format = locale === 'en' ? 'DD/MM/YYYY\nhh:mm A' : 'DD/MM/YYYY\nHH:mm';
  return date ? dayjs.utc(date).local().format(format) : '';
};
